import React from 'react'
import type { ICellRendererParams } from 'ag-grid-community'
import { Horizontal, Vertical, Texto, MaterialIcon, GraviButton } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'

export function InvoiceNumbersCellRenderer({ data }: ICellRendererParams<Match>) {
  const invoiceNumbers = data?.invoice_numbers || []

  if (!invoiceNumbers.length)
    return (
      <Tooltip title='Find Invoice Match'>
        <GraviButton appearance='link' style={{ height: 'auto', padding: 0 }}>
          <Horizontal verticalCenter style={{ overflow: 'visible' }} gap={4}>
            <MaterialIcon style={{ color: 'var(--theme-error)' }} icon='warning' />
            <Texto appearance='hint'>N/A</Texto>
          </Horizontal>
        </GraviButton>
      </Tooltip>
    )

  return (
    <Vertical justifyContent='center' style={{ gap: '4px', overflow: 'visible' }}>
      {invoiceNumbers.map((invoice, index) => (
        <div key={invoice.id || `${invoice.number}-${index}`}>
          <Texto>{invoice.number}</Texto>
        </div>
      ))}
    </Vertical>
  )
}
